import { BaseWalletConnect } from './client';
import type { WalletConnectConfig } from './types';

export class TonPassConnect extends BaseWalletConnect {
  constructor(config: Omit<WalletConnectConfig, 'walletId'>) {
    super({ ...config, walletId: 'tonpass' });
  }
}
